export default __webpack_public_path__ + "components/profile/static/icon-arrow-left-fe4896991dce00a81a207df350d901e1.svg";